import React, { Fragment } from "react";
import { Row, Col, Card, Form, Button } from "react-bootstrap";

const NoteJunior = (props) => {
    return (
        <>
            <Row>
                <Card>
                    <Form>
                        <Card.Header><h4 className="card-title">Note private</h4></Card.Header>
                        <Card.Body>

                            <Row className="mt-3 mb-4">
                                <Col className="col">
                                    <Form.Label>Stato profilo</Form.Label>
                                    <i className="fa fa-circle text-success me-1"></i> Attivo
                                </Col>
                            </Row>
                           
                            <Row className="mt-4">
                                <Form.Label>Note</Form.Label>
                                <Form.Control as="textarea" placeholder="A wonderful serenity has take possession of my entire soul like these sweet morning of spare which enjoy whole heart." {...props.isDisabled && { disabled: true }} />
                            </Row>

                        </Card.Body>
                        
                    </Form>
                </Card>
            </Row>
            {!props.isDisabled && <div className="d-flex justify-content-end mt-4"><Button type="button" className="btn btn-primary btn-add">Salva</Button></div> }
        </>
    )
}
export default NoteJunior;